var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.detailsObject)?_c('div',{staticClass:"c-details-list"},_vm._l((_vm.detailsObject),function(value,key,index){return _c('div',{key:index},[_c('span',{staticClass:"d-block mb-1"},[_c('b',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.$t(`${_vm.translationPath}.${key}`))+":")]),_vm._v(" "+_vm._s(value)+" ")])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }